"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventManager = exports.Event = void 0;
let Event = exports.Event = /*#__PURE__*/function (Event) {
  Event[Event["Show"] = 0] = "Show";
  Event[Event["Clear"] = 1] = "Clear";
  Event[Event["DidMount"] = 2] = "DidMount";
  Event[Event["WillUnmount"] = 3] = "WillUnmount";
  Event[Event["Change"] = 4] = "Change";
  Event[Event["ClearWaitingQueue"] = 5] = "ClearWaitingQueue";
  return Event;
}({});
const eventManager = exports.eventManager = {
  list: new Map(),
  emitQueue: new Map(),
  on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off(event, callback) {
    if (callback) {
      const cb = this.list.get(event).filter(cb => cb !== callback);
      this.list.set(event, cb);
      return this;
    }
    this.list.delete(event);
    return this;
  },
  emit(event, ...args) {
    this.list.has(event) && this.list.get(event).forEach(callback => {
      const timer = setTimeout(() => {
        callback(...args);
      }, 0);
      this.emitQueue.has(event) || this.emitQueue.set(event, []);
      this.emitQueue.get(event).push(timer);
    });
  }
};